import config from '../config.json'
import naturalCompare from './naturalCompareStrings'

const seperateAttributes = (attributes) => {
    const technologyAttributesSorted = attributes.sort((a, b) => naturalCompare(a.name, b.name))
    const withIconArray = []
    const withoutIconArray = []

    technologyAttributesSorted.map(attr => {
        if(attr.id !== 'digital') {
            if(_.contains(config.attributesWithIcons, attr.id)) {
                withIconArray.push(attr)
            } else {
                withoutIconArray.push(attr)
            }
        }
    })

    return {
        technologyAttributesWithoutIcons: withoutIconArray,
        technologyAttributesWithIcons: withIconArray
    }
}

export default seperateAttributes